import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ModalEl, VerticalAlignment } from "common/components/modal";
import { SelectEl } from "common/components/select";
import { FileUploaderEl } from "common/components/file-uploader";
import { ButtonTheme } from "common/components/button/constants";
import { SvgIconEl } from "common/components/svg-icon";
import { ConfirmEl } from "common/components/confirm";
import { THEME } from "common/components/confirm/types";
import { QueryBlockEl } from "common/query-builder/query-block";
export function template() {
  const { state, helpers } = this;
  return /* @__PURE__ */ jsx("div", {
    sel: ".map-lookup-table-modal"
  }, /* @__PURE__ */ jsx(ModalEl, {
    attrs: {
      open: this.attr(`open`),
      closeable: true,
      "grow-to-content": true,
      "vertical-alignment": this.attr(`type`) === `import` ? VerticalAlignment.Top : VerticalAlignment.Center
    },
    on: {
      change: (ev) => helpers.handleModalClose(ev)
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-modal-content"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-confirm-title"
  }, helpers.getModalTitle()), /* @__PURE__ */ jsx("div", {
    sel: ".section-title"
  }, "Lookup Table"), state.selectTableErrorMessage ? /* @__PURE__ */ jsx("div", {
    sel: ".input-row-error"
  }, state.selectTableErrorMessage) : null, /* @__PURE__ */ jsx("div", {
    sel: ".input-row"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".select-group",
    class: { hidden: state.hideSelect || this.attr(`type`) === `import` }
  }, /* @__PURE__ */ jsx(SelectEl, {
    attrs: {
      sections: helpers.getLookupTableSections(),
      "selected-option": helpers.getSelectedLabel(),
      "search-placeholder": `Search`,
      disabled: Boolean(state.fileProcessingDescription),
      elref: `lookupTableSelect`
    },
    on: {
      change: helpers.selectLookupTable
    }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".or"
  }, "or")), /* @__PURE__ */ jsx(FileUploaderEl, {
    attrs: helpers.getFileUploadBlockAttrs(),
    on: {
      change: helpers.uploadLookupTableCSV,
      delete: helpers.handleDeleteUpload
    }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".section-title"
  }, "Map to Property"), state.invalidPropertyErrorMessage ? /* @__PURE__ */ jsx("div", {
    sel: ".input-row-error"
  }, state.invalidPropertyErrorMessage) : null, state.requireOverwriteConfirmation ? /* @__PURE__ */ jsx("div", {
    sel: ".input-row-warning"
  }, "This property has an existing mapping that will be overwritten.") : null, /* @__PURE__ */ jsx(QueryBlockEl, {
    attrs: helpers.getQueryBlockAttrs(),
    on: { select: helpers.handleSelectProperty, remove: helpers.handleRemoveProperty }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".button-row"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".info-link"
  }, /* @__PURE__ */ jsx("a", {
    attrs: {
      href: `https://help.mixpanel.com/hc/en-us/articles/360044139291-Lookup-tables`,
      target: `_blank`
    },
    on: {
      click: helpers.trackInfoClick
    }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `info` }
  }), "Learn more about Lookup Tables")), /* @__PURE__ */ jsx("div", {
    sel: ".right-buttons"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".cancel-button-wrapper"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    attrs: { theme: ButtonTheme.Tertiary, tabindex: 0 },
    on: { click: helpers.handleCancel }
  }, "Cancel")), /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Primary,
      disabled: helpers.shouldDisableConfirm(),
      icon: state.savePending ? `spinner` : ``,
      tabindex: 0,
      elref: `applyMappingButton`
    },
    on: { click: helpers.handleConfirmClick }
  }, helpers.getConfirmButtonLabel()))), /* @__PURE__ */ jsx(ConfirmEl, {
    attrs: {
      open: state.overwriteModalOpen,
      closeable: false,
      "remove-host-style": true,
      "grow-to-content": true,
      "not-fullscreen": true,
      title: `Overwrite Property Mapping`,
      description: `The Property chosen is already mapped, overwrite?`,
      theme: THEME.CONFIRM,
      "confirm-button-label": `Confirm`,
      "cancel-button-label": `Cancel`
    },
    on: {
      submit: helpers.handleConfirmationModal
    }
  }))));
}
